import React from "react";
import { connect } from "react-redux";
import * as actions from "../redux/actions/summaryByUserActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/SummaryByCountry.css";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

const PROFILE_SECTIONS = [
  { title: "sales", activeKey: "SalesActive", inactiveKey: "SalesInActive" },
  { title: "rents", activeKey: "RentsActive", inactiveKey: "RentsInActive" },
  {
    title: "exchanges",
    activeKey: "ExchangesActive",
    inactiveKey: "ExchangesInActive",
  },
  {
    title: "donations",
    activeKey: "DonationsActive",
    inactiveKey: "DonationsInActive",
  },
];

class ProfileSummary extends React.Component {
  componentDidMount() {
    this.fecthLoadSummary();
  }

  fecthLoadSummary = async () => {
    try {
      await this.props
        .LoadSummary(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  renderSection = ({ title, activeKey, inactiveKey }) => {
    const { summary } = this.props;

    return (
      <div className="summary-card__section" key={title}>
        <div className="summary-card__section-title">
          <Translate value={title} />
        </div>
        <div className="summary-stat-row">
          <span className="summary-stat-row__label">
            <Translate value="ads_active" />
          </span>
          <span className="summary-stat-row__value">{summary[activeKey]}</span>
        </div>
        <div className="summary-stat-row">
          <span className="summary-stat-row__label">
            <Translate value="ads_inactive" />
          </span>
          <span className="summary-stat-row__value">
            {summary[inactiveKey]}
          </span>
        </div>
      </div>
    );
  };

  render() {
    const { summary } = this.props;

    return (
      <div className="Summary">
        <div className="card summary-card">
          <div className="summary-card__header">
            <h4 className="summary-card__title">
              <Translate value="summary" />
            </h4>
          </div>
          <div className="summary-card__body summary-card__body--profile">
            <div className="summary-card__highlight">
              <span className="summary-card__highlight-label">
                <Translate value="ads_available" />
              </span>
              <span className="summary-card__highlight-value">
                {summary.AdAvailable}
              </span>
            </div>
            {PROFILE_SECTIONS.map(this.renderSection)}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    summary: reducer.summaryByUser.item,
    error: reducer.summaryByUser.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadSummary: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSummary);
